module.exports = __webpack_public_path__ + "img/173-43ce2b.png";